import { useEffect, useState } from "react";
import "./PreferencesSettings.css";
import { useTheme } from "../../../context/ThemeContext";
import {
  MdLanguage,
  MdPalette,
  MdAccessTime,
  MdCurrencyRupee,
  MdDashboard,
  MdNotifications,
  MdSave,
} from "react-icons/md";

import {
  getPreferences,
  updatePreferences,
} from "../../services/preferencesSettingsService";

function PreferencesSettings() {
  const [preferences, setPreferences] = useState({
    language: "English",
    theme: "light",
    timeFormat: "12",
    currency: "INR",
    dashboardPage: "dashboard",
    notifications: {
      sound: true,
      desktop: true,
      browser: true,
    },
  });

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const { setTheme } = useTheme();

  useEffect(() => {
    fetchPreferences();
  }, []);

  const fetchPreferences = async () => {
    try {
      const res = await getPreferences();

      if (res.success && res.preferences) {
  setPreferences(res.preferences);

  // Apply saved theme immediately
  setTheme(res.preferences.theme);
}
    } catch (error) {
      console.error("Error loading preferences:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setPreferences({
      ...preferences,
      [e.target.name]: e.target.value,
    });
  };

  const handleNotificationToggle = (field) => {
    setPreferences((prev) => ({
      ...prev,
      notifications: {
        ...prev.notifications,
        [field]: !prev.notifications[field],
      },
    }));
  };

  const handleSave = async () => {
    try {
      setSaving(true);

      const res = await updatePreferences(preferences);

     if (res.success) {
  // Apply theme immediately
  setTheme(preferences.theme);

  alert("Preferences updated successfully.");
}
    } catch (error) {
      console.error(error);
      alert("Failed to update preferences.");
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div className="preferences-page">
        <h2>Loading Preferences...</h2>
      </div>
    );
  }

  return (
    <div className="preferences-page">

      <div className="preferences-header">
        <h1>Preferences</h1>
        <p>Personalize your dashboard experience.</p>
      </div>

      {/* Language */}

      <div className="preferences-card">

        <h2>
          <MdLanguage />
          Language
        </h2>

        <select
          name="language"
          value={preferences.language}
          onChange={handleChange}
        >
          <option>English</option>
          <option>Kannada</option>
          <option>Hindi</option>
          <option>Telugu</option>
          <option>Tamil</option>
          <option>Malayalam</option>
        </select>

      </div>

      {/* Theme */}

      

      <div className="preferences-card">

        

        <h2>
          <MdPalette />
          Theme
        </h2>

        <select
          name="theme"
          value={preferences.theme}
          onChange={handleChange}
        >
          <option value="light">Light</option>
          <option value="dark">Dark</option>
        </select>

      </div>

      {/* Time Format */}

      <div className="preferences-card">

        <h2>
          <MdAccessTime />
          Time Format
        </h2>

        <select
          name="timeFormat"
          value={preferences.timeFormat}
          onChange={handleChange}
        >
          <option value="12">12 Hour</option>
          <option value="24">24 Hour</option>
        </select>

      </div>

      {/* Currency */}

      <div className="preferences-card">

        <h2>
          <MdCurrencyRupee />
          Currency
        </h2>

        <select
          name="currency"
          value={preferences.currency}
          onChange={handleChange}
        >
          <option value="INR">Indian Rupee (INR)</option>
        </select>

      </div>

      {/* Dashboard */}

      <div className="preferences-card">

        <h2>
          <MdDashboard />
          Default Dashboard Page
        </h2>

        <select
          name="dashboardPage"
          value={preferences.dashboardPage}
          onChange={handleChange}
        >
          <option value="dashboard">Dashboard</option>
          <option value="orders">Orders</option>
          <option value="foods">Food Management</option>
          <option value="analytics">Analytics</option>
          <option value="reviews">Reviews</option>
          <option value="business">Business Management</option>
        </select>

      </div>

      {/* Notifications */}

      <div className="preferences-card">

        <h2>
          <MdNotifications />
          Notifications
        </h2>

        <div className="toggle-row">
          <span>Sound Notifications</span>

          <input
            type="checkbox"
            checked={preferences.notifications.sound}
            onChange={() => handleNotificationToggle("sound")}
          />
        </div>

        <div className="toggle-row">
          <span>Desktop Notifications</span>

          <input
            type="checkbox"
            checked={preferences.notifications.desktop}
            onChange={() => handleNotificationToggle("desktop")}
          />
        </div>

        <div className="toggle-row">
          <span>Browser Notifications</span>

          <input
            type="checkbox"
            checked={preferences.notifications.browser}
            onChange={() => handleNotificationToggle("browser")}
          />
        </div>

      </div>

      <div className="preferences-footer">

        <button
          className="save-preferences-btn"
          onClick={handleSave}
          disabled={saving}
        >
          <MdSave />

          {saving ? "Saving..." : "Save Preferences"}
        </button>

      </div>

    </div>
  );
}

export default PreferencesSettings;